import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './WhoNeeds.module.scss';

export const WhoNeedsStepTwoSection = () => (
  <AboutPageLayout
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.stepSection_1}>
          Who <span>needs</span>
        </div>
        <div className={styles.stepSection_2}>
          Transparen <br /> Terra?
        </div>
      </div>
    }
    rightContent={
      <div className={styles.stepContent}>
        <h3>TransparenTerra enables</h3>
        <ul>
          <li>businesses to demonstrate and prove their transparency;</li>
          <li>
            a community of experts to build a resilient environment for <br /> sustainable projects
            and investments;
          </li>
          <li>
            professional investors to find sustainable projects by <br /> leveraging approved ESG
            rates;
          </li>
          <li>individuals to make the best choices for themselves and the planet.</li>
        </ul>
      </div>
    }
  />
);
